module.exports = __webpack_public_path__ + "media/img/cart-cancellation-pending-334676634abebe88fdd55370378f0d7c.png";